export function formatDurationSeconds(ms: number): string {
  return (ms / 1000).toFixed(1);
}
